import { GET_USER_WAREHOUSES } from 'actions/types';

const initialState = {
  userId: '',
  data: [],
  isLoading: false,
};

/**
  @description Stores the warehouse ids of the user being edited in redux state
  @param {{}} state
  @param {{
  payload : { id: string, warehouse_ids: string[] }
  type : string
   }} action
  @returns {{}}
 */
function userWarehouses(state = initialState, action) {
  const { type, payload } = action;

  if (type === GET_USER_WAREHOUSES) {
    return {
      userId: '',
      data: [],
      isLoading: true,
    };
  }

  if (type === `${GET_USER_WAREHOUSES}_SUCCESS`) {
    return {
      userId: payload.id,
      data: payload.warehouse_ids,
      isLoading: false,
    };
  }

  if (type === `${GET_USER_WAREHOUSES}_FAILURE`) {
    return initialState;
  }

  return state;
}

export default userWarehouses;
